import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=2463c00a"
import script from "./hint.vue?vue&type=script&lang=js"
export * from "./hint.vue?vue&type=script&lang=js"
import style0 from "./hint.vue?vue&type=style&index=0&id=2463c00a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports